import { useEffect } from "react";

/**
 * @description 点击外部触发
 */
export function useOnClickOutside(ref: any, callback: any) {
  useEffect(() => {
    /**
     * @description handler
     */
    function handler(event: any) {
      if (!ref.current?.contains(event.target)) {
        callback();
      }
    }
    window.addEventListener('click', handler);

    return () => window.removeEventListener('click', handler)
  }, [callback, ref]);
}
